import React from 'react'
import Menu from '../components/Navbar'
import { Container } from 'react-bootstrap'
import Swiper from '../components/Swiper'
import Card from '../components/Card'
import Footer from '../components/Footer'

// image import 1-7
import Portfolio1 from '../img/portofolio/portfolio1.jpg'
import Portfolio2 from '../img/portofolio/portfolio2.jpg'
import Portfolio3 from '../img/portofolio/portfolio3.jpg'
import Portfolio4 from '../img/portofolio/portfolio4.jpg'
import Portfolio5 from '../img/portofolio/portfolio5.jpg'
import Portfolio6 from '../img/portofolio/portfolio6.jpg'

// image import 1-14
// import Portfolio8 from '../img/portofolio/porto-8.png'
// import Portfolio9 from '../img/portofolio/porto-9.png'
// import Portfolio10 from '../img/portofolio/porto-10.png'
// import Portfolio11 from '../img/portofolio/porto-11.png'
// import Portfolio12 from '../img/portofolio/porto-12.png'
// import Portfolio13 from '../img/portofolio/porto-13.png'
// import Portfolio14 from '../img/portofolio/porto-14.png'

const Portfolio = () => {

  // Props Swiper 1-7
  const Image = () => {
    return <img src={Portfolio1} alt="" />
  }
  const Image2 = () => {
    return <img src={Portfolio2} alt="" />
  }
  const Image3 = () => {
    return <img src={Portfolio3} alt="" />
  }
  const Image4 = () => {
    return <img src={Portfolio4} alt="" />
  }
  const Image5 = () => {
    return <img src={Portfolio5} alt="" />
  }
  const Image6 = () => {
    return <img src={Portfolio6} alt="" />
  }

  // Props Swiper 8-14
  // const Image8 = () => {
  //   return <img src={Portfolio8} alt="" />
  // }
  // const Image9 = () => {
  //   return <img src={Portfolio9} alt="" />
  // }
  // const Image10 = () => {
  //   return <img src={Portfolio10} alt="" />
  // }
  // const Image11 = () => {
  //   return <img src={Portfolio11} alt="" />
  // }
  // const Image12 = () => {
  //   return <img src={Portfolio12} alt="" />
  // }
  // const Image13 = () => {
  //   return <img src={Portfolio13} alt="" />
  // }
  // const Image14 = () => {
  //   return <img src={Portfolio14} alt="" />
  // }



  // Props Cara Kerja
  const Title = () => {
    return <h1 className="titleText">Konsultasi Awal</h1>;
  }
  const Typography = () => {
    return <p className="textTyphograph">Kami memulai dengan konsultasi awal tanpa biaya untuk memahami kebutuhan proyek
Anda. Dari sini, tim Mortara memberi arahan terkait ruang lingkup pekerjaan dan
estimasi biaya.</p>;
  }
  const Title2 = () => {
    return <h1 className="titleText">Survey & Perencanaan</h1>
  }
  const Typography2 = () => {
    return <p className="textTyphograph">Setelah kesepakatan awal, Mortara melakukan survey lapangan dan mulai menyusun
perencanaan pekerjaan, termasuk kebutuhan desain dan gambar kerja. Pada tahap ini
dilakukan pembayaran tanda jadi sebagai bagian dari konfirmasi kerja sama.</p>
  }
  const Title3 = () => {
    return <h1 className="titleText">Kontrak & Surat Perintah Kerja</h1>;
  }
  const Typography3 = () => {
    return <p className="textTyphograph">Tahap berikutnya adalah penyusunan Kontrak Kerja dan Surat Perintah Kerja (SPK) setelah RAB disetujui. Dokumen ini memuat detail kerja sama, termasuk: <br/> <br/> 1.Hak dan kewajiban kedua belah pihak <br/> <br/> 2. Jadwal dan Termin Pembayaran <br/> <br/> 3.Gambar kerja serta dokumen desain <br/> <br/> 4.Rencana Anggaran Biaya (RAB) <br/> <br/> 5.Spesifikasi material dan standar pekerjaan <br/> <br/> Kontrak ini menjadi dasar pelaksanaan agar seluruh proses berjalan jelas dan terukur.</p>;
  }
  const Title4 = () => {
    return <h1 className="titleText">Pembayaran Bertahap</h1>;
  }
  const Typography4 = () => {
    return <p className="textTyphograph">Pembayaran dilakukan secara bertahap sesuai termin yang tercantum dalam kontrak.
Mortara akan menerbitkan invoice pada setiap tahap pekerjaan, mengikuti progres dan
kesepakatan yang telah ditentukan sebelumnya.</p>;
  }
  const Title5 = () => {
    return <h1 className="titleText">Tahap Pembangunan</h1>;
  }
  const Typography5 = () => {
    return <p className="textTyphograph">Pekerjaan konstruksi dijalankan berdasarkan gambar kerja, RAB, dan spesifikasi yang
tercantum dalam kontrak. Selama pengerjaan, tim Mortara melakukan pengawasan rutin
untuk menjaga kualitas, ketertiban proses, dan kesesuaian dengan rencana awal.</p>;
  }
  const Title6 = () => {
    return <h1 className="titleText">Serah Terima Pekerjaan</h1>;
  }
  const Typography6 = () => {
    return <p className="textTyphograph">Setelah pekerjaan selesai, tim Mortara dan klien melakukan pemeriksaan bersama (quality control)
untuk memastikan seluruh pekerjaan sesuai gambar kerja, spesifikasi, dan standar yang disepakati.
Proyek kemudian diserahterimakan melalui Berita Acara Serah Terima (BAST), termasuk garansi
pemeliharaan selama 1 bulan.</p>;
  }
  return (
    <>
    <Menu />

    <Container fluid className="content-portfolio">
        <div className="Image-portfolio">
            <div className="container-image1">
                <div className="paragrafPortfolio">
                    <h1>Our Portfolio</h1>
                </div>
            </div>
        </div>
    </Container>
    
    <Swiper image={Image()} image2={Image2()} image3={Image3()} image4={Image4()} image5={Image5()} image6={Image6()}/>
    {/* <Swiper image={Image8()} image2={Image9()} image3={Image10()} image4={Image11()} image5={Image12()} image6={Image13()} image7={Image14()}/> */}

    <Container fluid className="containerCaraKerja">
      <div className="caraKerja">
        <div className="titleCaraKerja">
          <h1>Cara Kerja</h1>
        </div>
        <div className="contentCaraKerja">
          <Card  nomor="1." title={Title()} typography={Typography()} />
          <Card  nomor="2." title={Title2()} typography={Typography2()} />
          <Card  nomor="3." title={Title3()} typography={Typography3()} />
        </div>
        <div className="contentCaraKerja">
          <Card  nomor="4." title={Title4()} typography={Typography4()} />
          <Card  nomor="5." title={Title5()} typography={Typography5()} />
          <Card  nomor="6." title={Title6()} typography={Typography6()} />
        </div>
      </div>
    </Container>
    
    <Footer />
    </>
  )
}

export default Portfolio
